import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';

export const Container = styled.div`
  position: relative;
`;

export const InputWrapper = styled.div`
  position: relative;

  /* Si l'élément est vide, c'est que le chargement de googlemaps
  est toujours en cours. Dans ce cas, on affiche un placeholder. */
  &:empty {
    height: 56px;
    opacity: 0.5;
    border-radius: 4px;
    background: ${COLORS.NEUTRAL_WHITE};
    border: solid 1px ${COLORS.NEUTRAL_STROKE};
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 5;
  margin-top: 8px;

  > * {
    margin: 0;
  }
`;

export const NoDelivery = styled.div`
  border-radius: 4px;
  padding: 17px 17px 10px;
  border: 1px solid ${COLORS.NEUTRAL_STROKE};
  background-color: ${COLORS.NEUTRAL_WHITE};

  p {
    margin: 0;

    span span {
      font-weight: 500;
    }
  }

  button {
    display: block;
    margin: 0;
    padding: 0;
    width: 100%;

    & > div {
      justify-content: space-between;

      & > span {
        margin: 0 !important;
        padding: 0 !important;

        &:first-of-type {
          font-weight: 500;
          font-size: 14px;
        }
      }
    }
  }
`;
